<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('change_of_class_request_form')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('change_of_class_request_form')"
                              :isFilter="false"/>
            </template>
            <div class="row data-form">
                <div class="col-12">
                    <div class="mb-4">
                        <h6 class="text-uppercase mb-0">{{ $t('information').toUpper() }}</h6>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('student_number_long')">{{ leaveStudentData.student_id}}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('name_surname')">{{leaveStudentData.student_name}}</b-form-group>
                </div>


                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('current_class')">{{ leaveStudentData?.current_class?.name }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('teacher')">{{ leaveStudentData?.current_teacher?.name}} {{ leaveStudentData?.current_teacher?.surname}}</b-form-group>
                </div>

            </div>
            <hr>
            <div class="my-3 d-inline-block"></div>
            <div class="mb-4">
                <h6 class="text-uppercase mb-0">{{ $t('application_information').toUpper() }}</h6>
            </div>
            <ValidationObserver ref="leaveForm">
              <b-row>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <ValidationProvider name="module_date_id" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('Please select the module for which you are requesting a class change')">
                                <multi-selectbox
                                    v-model="form.module_date_id" :multiple="false"
                                    :options="availableModuleOptions" :validate-error="errors[0]"
                                ></multi-selectbox>
                            </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="type" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('type')">
                                <parameter-selectbox code="change_of_class_request_types" sort="rank" v-model="form.type"
                                                 :state="errors[0] ? false : null">
                                </parameter-selectbox>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                      <ValidationProvider name="reason" rules="required" v-slot="{valid, errors}">
                          <b-form-group :label="$t('reason')">
                              <parameter-selectbox code="change_of_class_request_reasons" v-model="form.reason"
                                                   :state="errors[0] ? false : null">
                              </parameter-selectbox>
                          </b-form-group>
                      </ValidationProvider>
                      <ValidationProvider name="explanation" rules="required" v-slot="{valid, errors}">
                          <b-form-group :label="$t('explanation')">
                              <b-form-textarea v-model="form.explanation"
                                               :state="errors[0] ? false : null">
                              </b-form-textarea>
                          </b-form-group>
                      </ValidationProvider>

                  </div>
            </b-row>
            </ValidationObserver>
            <div class="d-flex justify-content-center">
                <b-form-group>
                    <b-button variant="primary" @click="save">{{ $t('save') }}</b-button>
                </b-form-group>
            </div>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from '@/layouts/AppLayout';
import Header from '@/layouts/AppLayout/Header';
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';

import EslChangeOfClassRequestService from "@/services/EslChangeOfClassRequestService";

// Other
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";

export default {
    components: {
        MultiSelectbox,
        AppLayout,
        Header,
        HeaderMobile,
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            form:{},
            formProcess:null,
            leaveStudentData:{},
        }
    },
    metaInfo() {
        return {
            title: this.$t('change_of_class_request_form')
        }
    },
    computed:  {
        availableModuleOptions(){
            let options=[]
            if (!this.leaveStudentData.available_modules){
                return []
            }
            options=this.leaveStudentData.available_modules.map(item=>{
                return {
                    text:item.name??null,
                    value:item.id??null
                }
            })
            return options
        }
    },
    methods: {
        async getFormData() {
            try {
                const response = await EslChangeOfClassRequestService.studentFormRequest()
                this.leaveStudentData=response.data.data
            }catch (error) {
                this.showErrors(error)
            }
        },
       async save(){
            if (!await this.$refs.leaveForm.validate()) return
            try {
                const res=await EslChangeOfClassRequestService.store(this.form)
                this.$toast.success(this.$t(res.data.message))
                this.$router.push('/my-mentora-requests/0')
            }catch (error){
                this.showErrors(error,this.$refs.leaveForm)
            }
        }
    },
    created() {
        this.getFormData()
    },
};
</script>
